import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { px2rem } from '../utils/helpers/style.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var toggleAttributesNative = {
  width: 64,
  height: 32,
  labelMargin: 16,
  color: 'primary',
  fontSize: 'l',
  slider: {
    width: 28,
    height: 28,
    padding: 2,
    colors: {
      "default": 'widget.control',
      disabled: 'button.disabled'
    }
  },
  locked: {
    iconSize: 20,
    inactiveMargin: 34,
    activeMargin: 9
  },
  background: {
    disabled: 'border.disabled',
    inactive: 'widget.inactive'
  },
  icon: {
    size: 18,
    colors: {
      disabled: 'text.disabled'
    }
  },
  switchOrientation: 'left'
};
var toggleThemeNative = _objectSpread(_objectSpread({}, toggleAttributesNative), {}, {
  variants: {
    condensed: {
      width: 48,
      height: 24,
      fontSize: 'm',
      slider: {
        width: 18,
        height: 18,
        padding: 3
      },
      locked: {
        iconSize: 16,
        inactiveMargin: 24,
        activeMargin: 8
      }
    }
  }
});
var toggleThemeWeb = {
  color: 'primary',
  textColor: 'text',
  background: {
    disabled: 'border.disabled',
    inactive: 'widget.inactive'
  },
  slider: {
    colors: {
      "default": 'widget.control',
      disabled: 'button.disabled'
    }
  },
  locked: {
    iconSize: 20,
    inactiveMargin: px2rem(34),
    activeMargin: px2rem(9)
  }
};

export { toggleThemeNative, toggleThemeWeb };
